function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components/Checkbox/Active",
  transform: "translate(-3.000000, -4.000000)",
  fill: "#3cb950"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.8760583,4.72739705 L11.6350716,4.5203599 C11.2350542,4.17660701 10.6339455,4.21492412 10.2807785,4.60655503 L6.24937119,9.07659039 L5.03247277,8.02852213 C4.63287747,7.68438387 4.03167695,7.72193023 3.67808787,8.11313907 L3.4650132,8.34891406 C3.29221921,8.54000411 3.20250066,8.79207487 3.21552994,9.04955922 C3.22868768,9.30689675 3.34349219,9.54848904 3.53487586,9.72120963 L5.76550762,11.7638894 C5.95863464,11.9452533 6.21745862,12.0398349 6.48200813,12.0257963 C6.74655765,12.0117945 6.99389383,11.8902551 7.16670618,11.689439 L11.9791915,6.097674 C12.1473243,5.90230815 12.2309136,5.64818206 12.2115348,5.3912299 C12.1921744,5.13409422 12.0715343,4.89534636 11.8760583,4.72739705 Z",
  id: "Path"
}))));

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "15px",
    viewBox: "0 0 10 8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.cbd61fd4.svg";
export { ForwardRef as ReactComponent };